import { render } from "./PushNotificationForm.vue?vue&type=template&id=78858dbf&ts=true"
import script from "./PushNotificationForm.vue?vue&type=script&lang=ts"
export * from "./PushNotificationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/clickfun/frontend/clickfun_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__